import type { SVGProps } from 'react';

const MONDU_LOGO_MASK_ID = 'mondu-logo-mask';

const MonduLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 113 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      id={MONDU_LOGO_MASK_ID}
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="113"
      height="29"
    >
      <path d="M113 0H0V28.25H113V0Z" fill="white" />
    </mask>
    <g mask={`url(#${MONDU_LOGO_MASK_ID})`}>
      <path
        d="M58.3086 27.5576H53.6438V8.43233H58.1882V10.985C59.3969 8.99839 61.6152 7.81108 63.9794 7.88231C68.7646 7.88231 71.0578 11.2609 71.0578 15.4619V27.5594H66.393V16.2487C66.393 13.8937 65.3065 12.0068 62.3716 12.0068C59.7158 12.0068 58.3104 14.0093 58.3104 16.5229V27.5576H58.3086Z"
        fill="currentColor"
      />
      <path
        d="M103.027 28.1076C98.3625 28.1076 95.6265 24.729 95.6265 20.4888V8.43048H100.291V19.6628C100.291 22.0179 101.418 24.0223 104.232 24.0223C107.047 24.0223 108.335 22.2564 108.335 19.7412V8.43048H113V24.0597C113 25.6297 112.92 26.8491 113 27.5557H108.576C108.536 26.8491 108.536 26.1406 108.576 25.4356C107.612 27.1641 105.319 28.1058 103.025 28.1058"
        fill="currentColor"
      />
      <path
        d="M22.5052 7.88048C19.9022 7.73807 17.4413 9.04643 16.1507 11.2591C15.0697 9.0785 12.7547 7.74697 10.2792 7.88048C7.94775 7.81996 5.75301 8.95211 4.4879 10.8657V8.43231H0L0.0236974 27.5576H4.65197V16.2077C4.65197 13.7726 6.22147 11.9658 8.71333 11.9658C11.3693 11.9658 12.494 13.6943 12.494 15.8927V27.5576H17.0749V16.2077C16.9254 14.0165 18.6207 12.1224 20.8647 11.9747C20.9558 11.9694 21.0451 11.9658 21.1362 11.9658C23.7503 11.9658 24.9169 13.6533 24.9169 15.8927V27.5576H29.4212V15.1432C29.4212 10.0771 26.0434 7.87872 22.5034 7.87872"
        fill="currentColor"
      />
      <path
        d="M92.8405 0L88.0937 1.51486V10.6699C87.4903 9.45228 85.7624 7.92141 82.3424 7.92141C76.8283 7.92141 73.0132 12.4375 73.0132 17.9326C73.0132 23.7054 76.7937 28.0293 82.4229 28.0293C84.7433 28.1308 86.9397 27.0057 88.1721 25.0832V27.5576H92.8369C92.7967 27.2443 92.8369 25.7917 92.8369 24.0615V0H92.8405ZM82.9477 24.0223C79.7706 24.0223 77.6797 21.5871 77.6797 17.9344C77.6797 14.2817 79.9327 11.9604 82.9879 11.9604C86.0431 11.9604 88.1358 14.2389 88.1358 17.8917C88.1358 21.5444 86.0047 24.0187 82.9477 24.0187"
        fill="currentColor"
      />
      <path
        d="M41.5395 7.94629C35.7083 7.94629 31.4062 12.2274 31.4062 18.0786C31.4062 23.9297 35.7101 28.25 41.5395 28.25C47.3692 28.25 51.7148 23.9689 51.7148 18.0786C51.7148 12.1882 47.4112 7.94629 41.5395 7.94629ZM46.5761 19.9886C46.5581 20.9249 45.9274 21.7438 45.0103 22.0215L36.7966 24.6471C36.6946 24.6791 36.5851 24.624 36.5523 24.5243C36.5466 24.5047 36.5431 24.4851 36.5431 24.4655V16.2024C36.5597 15.266 37.1921 14.4454 38.1088 14.1695L46.3247 11.5474C46.4267 11.5154 46.5362 11.5706 46.569 11.6702C46.5743 11.6898 46.5782 11.7094 46.5782 11.729V19.9904L46.5761 19.9886Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default MonduLogo;
